import Env from "../env/Env";
import createAxiosInstance from "../utils/axiosInstance";
import { defaultAPIsResponseType, defaultGraphsGetFiltersType } from "../consts/shared";

const basePath = '/api/graphs/dashboard-5';
const request = createAxiosInstance(`${Env.API_BASE}${basePath}`);

const dashboard5APIsService = {
  basePath,
  fetchLowestRatedCoursesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/lowest-rated-courses", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchOverallCourseRatingData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/overall-course-rating", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchHighestRatedCoursesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/highest-rated-courses", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchAverageCourseRatingByMonthData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/average-course-rating-by-month", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchIndividualCourseRatingWithCommentsData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/individual-course-rating-with-comments", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchRatingBreakdownData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/rating-breakdown", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchSummaryCardsData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/summary-cards", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
};

export default dashboard5APIsService;
